import clsx from 'clsx'
import { useState } from 'react'

import { FvButton } from '@fv/client-components'

import { ShipperOnly } from '@/features/auth/HasRole'
import type { ExportListType } from '@/features/shipment-list/hooks/useExportList'

import ExportOptions from './ExportOptions'

type ActiveShipmentsExportControlsProps = {
  queryString: string
  listType?: ExportListType
  buttonClassName?: string
}

export const ActiveShipmentsExportControls = ({
  queryString,
  listType,
  buttonClassName,
}: ActiveShipmentsExportControlsProps) => {
  const [isExporting, setIsExporting] = useState(false)

  return (
    <>
      <ShipperOnly permissions={['load-exporter']}>
        <FvButton
          icon="file-export"
          className={clsx('leading-normal', buttonClassName)}
          onClick={() => setIsExporting(true)}
        >
          Export <span className="b1450:hidden b1400:inline">list</span>
        </FvButton>
      </ShipperOnly>

      <ExportOptions
        closePanel={() => setIsExporting(false)}
        isOpen={isExporting}
        queryString={queryString}
        listType={listType}
      />
    </>
  )
}
